import { useEffect, useState } from 'react'
import ProjectsRoom, { preloadProjectsRoom } from './components/ProjectsRoom'
import projects from './components/ProjectsRoom/projects'

// ── A throwaway hash router so the demo can show "click a cutout → project page".
//    In your real portfolio, replace this with React Router / Next / whatever you use.
function useHashRoute() {
  const get = () => window.location.hash.replace(/^#/, '') || '/'
  const [route, setRoute] = useState(get)
  useEffect(() => {
    const on = () => setRoute(get())
    window.addEventListener('hashchange', on)
    return () => window.removeEventListener('hashchange', on)
  }, [])
  return route
}

const navigate = (path) => {
  if (!path) return

  if (path.startsWith('http')) {
    window.location.assign(path)
    return
  }

  const normalized = path.startsWith('/') ? path : `/${path}`

  sessionStorage.setItem('pr-scroll', String(window.scrollY))
  window.history.pushState({}, '', normalized)
  window.dispatchEvent(new PopStateEvent('popstate'))
  window.scrollTo(0, 0)
}

function Home() {
  // Coming back from a project page: return to where the visitor was.
  useEffect(() => {
    const y = Number(sessionStorage.getItem('pr-scroll') || 0)
    if (y) window.scrollTo(0, y)
  }, [])

  return (
    <main className="interactive-room-shell" onMouseEnter={preloadProjectsRoom} onFocus={preloadProjectsRoom}>
      <ProjectsRoom onSelect={(project) => navigate(project.href)} />
    </main>
  )
}

function ProjectPage({ slug }) {
  const project = projects.find((p) => p.href === `/work/${slug}`)
  useEffect(() => window.scrollTo(0, 0), [slug])

  if (!project) {
    return (
      <main className="project">
        <a className="project__back" href="#/">
          ← Back to work
        </a>
        <h1>Not found</h1>
      </main>
    )
  }
  return (
    <main className="project">
      <a className="project__back" href="#/">
        ← Back to work
      </a>
      <p className="project__kicker">{project.kicker}</p>
      <h1 className="project__title">{project.title}</h1>
      <p className="project__summary">{project.summary}</p>
      <div className="project__frames">
        {project.frames.map((src) => (
          <img key={src} src={src} alt="" />
        ))}
      </div>
      <p className="project__body">
        This is the demo project page. In your portfolio, <code>onSelect(project)</code> would route to your real case
        study.
      </p>
    </main>
  )
}

export default function App() {
  const route = useHashRoute()
  const match = route.match(/^\/work\/(.+)$/)
  return match ? <ProjectPage slug={match[1]} /> : <Home />
}
